import { Mtds, toLocaleDateString } from 'prove-common'
import type { CumulativeChartRow, PreviousMonthStatus } from './statisticsTypes'
import { formatCount } from './statisticsFormat'

const MetricCard = ({
  label,
  value,
  accent = 'text-text-primary',
  className = '',
  valueClassName = ''
}: {
  label: string
  value: string
  accent?: string
  className?: string
  valueClassName?: string
}) => (
  <Mtds.Card
    className={`w-full min-w-0 overflow-hidden text-text-primary ${className}`}
  >
    <Mtds.Prose className='min-w-0'>
      <Mtds.Info>
        <strong>{label}</strong>
        <Mtds.Heading
          data-size='2xl'
          className={`break-words ${accent} ${valueClassName}`}
        >
          {value}
        </Mtds.Heading>
      </Mtds.Info>
    </Mtds.Prose>
  </Mtds.Card>
)

export const CumulativeStatusCard = ({
  isCurrentReportingYear,
  previousMonthStatus,
  currentMonthData,
  targetMetricsApplicable = true
}: {
  isCurrentReportingYear: boolean
  previousMonthStatus: PreviousMonthStatus
  currentMonthData: CumulativeChartRow | undefined
  targetMetricsApplicable?: boolean
}) => {
  const previousMonthStatusDateLabel =
    toLocaleDateString(previousMonthStatus.statusDate) ?? ''
  const currentStatusDateLabel =
    toLocaleDateString(new Date().toISOString()) ?? ''
  const currentMonthPlanned = currentMonthData?.samplesPlanned ?? 0
  const currentMonthTaken = currentMonthData?.samplesTaken ?? 0

  if (!isCurrentReportingYear) return null

  return (
    <Mtds.Grid data-gap={6} className='grid content-start 2xl:grid-cols-2'>
      <Mtds.Grid>
        <Mtds.Heading className='text-text-primary' data-size='sm'>
          Forrige måned ({previousMonthStatusDateLabel})
        </Mtds.Heading>
        <Mtds.Grid className='sm:grid-cols-12'>
          <MetricCard
            label='Planlagt'
            value={
              targetMetricsApplicable
                ? formatCount(previousMonthStatus.planned)
                : '–'
            }
            className='sm:col-span-6'
          />
          <MetricCard
            label='Tatt'
            value={formatCount(previousMonthStatus.taken)}
            accent='text-warning-text-default'
            className='sm:col-span-6'
          />
        </Mtds.Grid>
      </Mtds.Grid>

      <Mtds.Grid>
        <Mtds.Heading
          className='whitespace-nowrap text-text-primary'
          data-size='sm'
        >
          Denne måneden ({currentStatusDateLabel})
        </Mtds.Heading>
        <Mtds.Grid className='sm:grid-cols-12'>
          <MetricCard
            label='Planlagt'
            value={
              targetMetricsApplicable ? formatCount(currentMonthPlanned) : '–'
            }
            className='sm:col-span-6'
          />
          <MetricCard
            label='Tatt'
            value={formatCount(currentMonthTaken)}
            accent='text-warning-text-default'
            className='sm:col-span-6'
          />
        </Mtds.Grid>
      </Mtds.Grid>
    </Mtds.Grid>
  )
}
